import { useFormikContext } from 'formik';
import { isEqual, omit, pick } from 'lodash';
import { useState } from 'react';

import { ItemModel } from '../../../common/models/ItemModel';
import { FormikCreateEnquiryValues } from '../../create-enquiry/CreateEnquiryFlow';

export const useDraftChanges = (initialValues: FormikCreateEnquiryValues) => {
    const [lastSavedValues, setLastSavedValues] = useState(initialValues);
    const [lastSuggestionValues, setLastSuggestionValues] = useState(initialValues);
    const { values } = useFormikContext<FormikCreateEnquiryValues>();

    return {
        hasUnsavedChanges: hasUnsavedChanges(lastSavedValues, values),
        hasSuggestionRelevantChanges: hasSuggestionRelevantChanges(lastSuggestionValues, values),
        setLastSavedValues,
        setLastSuggestionValues,
    };
};

const hasUnsavedChanges = (
    lastSavedValues?: FormikCreateEnquiryValues,
    currentValues?: FormikCreateEnquiryValues
): boolean => {
    if (!lastSavedValues || !currentValues) return false;
    const fieldsToIgnore = ['assignedSupplierIds', 'assignedSuppliers', 'orderMode'];
    const last = omit(lastSavedValues, fieldsToIgnore);
    const current = omit(currentValues, fieldsToIgnore);
    last.items = sanitizeItems(last);
    current.items = sanitizeItems(current);
    return !isEqual(last, current);
};

const hasSuggestionRelevantChanges = (
    lastSavedValues?: FormikCreateEnquiryValues,
    currentValues?: FormikCreateEnquiryValues
): boolean => {
    if (!lastSavedValues || !currentValues) return false;
    const fieldsToCompare = ['vesselId', 'items'];
    const last = pick(lastSavedValues, fieldsToCompare);
    const current = pick(currentValues, fieldsToCompare);
    last.items = sanitizeItems(last);
    current.items = sanitizeItems(current);
    return !isEqual(last, current);
};

const sanitizeItems = (values: Partial<FormikCreateEnquiryValues>) => {
    const itemFieldsToIgnore = ['volume', 'total'];
    return values?.items?.map((item) => omit(item, itemFieldsToIgnore) as ItemModel);
};
